export default "__VITE_ASSET__CTgQu6gU__"